import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState({});
  const clientId = localStorage.getItem("client_id");

  useEffect(() => {
    if(clientId){
      getData();
    }
  }, [navigate]);

  const getData = () => {
    axios
      .get(`/api/v1/customers/` + clientId)
      .then((res) => {
        setCustomerData(res.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <CustomerContext.Provider value={{ customerData, setCustomerData }}>
      {children}
    </CustomerContext.Provider>
  );
};
